<p-card styleClass="app-frame">
    <ng-template pTemplate="header">
        <h1>404: Page not found</h1>
    </ng-template>
    <div>
        <span (click)="this.goToHome()">It looks like we could find this page. Would you like to go to the home page?</span>
    </div>
    <ng-template pTemplate="footer">        
    </ng-template>
</p-card>